import styled from "styled-components";

export const EquipAnalysisContent = styled.div`
  overflow: hidden;
  display: flex;
  height: 100%;
  max-height: calc(100svh - 324px);
  flex-direction: column;
  gap: 16px;
`;

export const EquipAnalysisBox = styled.div`
  overflow-y: auto;
  display: grid;
  height: 100%;
  grid-template-columns: repeat(2, 1fr);
  grid-template-rows: repeat(8, minmax(40px, 1fr));
  gap: 16px;
`;
